import api from "../..";
import type { DeleteContentBannerParams, DeleteTopBannerParams } from "./types";
import { TOP_ENDPOINT, CONTENT_ENDPOINTS } from "./types";

export const deleteTopBanner = async ({
  uuid,
}: DeleteTopBannerParams): Promise<boolean> =>
  await api
    .delete(`${TOP_ENDPOINT}${uuid}/`)
    .then(() => true)
    .catch(() => false);

export const deleteContentBanner = async ({
  uuid,
  contentType,
}: DeleteContentBannerParams): Promise<boolean> =>
  await api
    .delete(`${CONTENT_ENDPOINTS[contentType]}${uuid}/`)
    .then(() => true)
    .catch(() => false);
